import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface BbgdexCarInfoOverviewProps {
  plates: any[]
}

const plateTypeMap: Record<string, string> = {
  small: '小型车辆',
  large: '大型车辆',
  newEnergySmall: '新能源小型',
  newEnergyLarge: '新能源大型',
}

export default function BbgdexCarInfoOverview({ plates }: BbgdexCarInfoOverviewProps) {
  const theme = useTheme()
  const totalPlates = plates.length

  const getVehicleTypeDistribution = () => {
    if (plates.length === 0) return '—'
    const typeCounts: Record<string, number> = {}

    plates.forEach((item: any) => {
      const type = item?.plateType
      if (type) {
        typeCounts[type] = (typeCounts[type] || 0) + 1
      }
    })

    const distribution = Object.entries(typeCounts)
      .map(([type, count]) => {
        const typeName = plateTypeMap[type] || type
        return `${typeName}${count}辆`
      })
      .join(' / ')

    return distribution || '—'
  }

  const getLatestBindTime = () => {
    if (plates.length === 0) return '—'
    const times = plates
      .map((item: any) => item?.bindTime)
      .filter((time: string) => time && time !== '')
      .sort((a: string, b: string) => b.localeCompare(a))
    return times.length > 0 ? times[0] : '—'
  }

  const vehicleDistribution = getVehicleTypeDistribution()
  const latestBindTime = getLatestBindTime()

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            车辆信息概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总ETC车辆绑定的整体情况,包括车辆数量、类型分布及最近绑定时间。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="绑定车辆总数" value={`${totalPlates} 辆`} subtitle="ETC绑定车辆" />
          <SummaryItem label="车辆类型分布" value={vehicleDistribution} subtitle="各类型车辆统计" />
          <SummaryItem label="最近绑定时间" value={latestBindTime} subtitle="最新绑定日期" />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
